const schema = {
  title: {
    type: 'text',
    label: 'Event Title',
    placeholder: 'Enter the question',
    required: true,
    info: true,
    character_count: 250,
    disabled: true
  },
  date: {
    type: 'date',
    label: 'Date',
    placeholder: 'Enter Date',
    required: true,
    info: true,
    wrapper_class: 'col-6'
  },
  start_time: {
    type: 'time',
    label: 'Time From',
    placeholder: '',
    required: true,
    info: true,
    wrapper_class: 'col-3'
  },
  end_time: {
    type: 'time',
    label: 'Time To',
    placeholder: '',
    required: true,
    info: true,
    wrapper_class: 'col-3'
  },
  description: {
    type: 'ckeditor',
    label: 'Description',
    required: true,
    info: false,
    character_count: 2000
  }
};

const meetings = [
  {
    id: "event01112021",
    active: true,
    date: "01 Nov 2021",
    timeFrom: "13:00",
    timeTo: "14:30",
    title: "Board Meeting",
    text: "<p>Lorem ipsum dolor sit amet, consect adipiscing elit. Morbi in finibus mauris, eu varius mauris. Sed luctus ipsum non varius placerat.</p><p>First Tuesday of each month</p>",
  },
  {
    id: "event25112021",
    active: true,
    date: "25 Nov 2021",
    title: "Scheduled Training",
    text: "<p>Mandatory Bluestream Training for all new staff members</p>",
  },
  {
    id: "event28112021",
    active: true,
    date: "28 Nov 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  },
  {
    id: "event29112021",
    active: true,
    date: "29 Nov 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  },
  {
    id: "event30112021",
    active: true,
    date: "30 Nov 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  },
  {
    id: "event01122021",
    active: true,
    date: "01 Dec 2021",
    timeFrom: "12:15",
    timeTo: "13:15",
    title: "Scheduled Meeting",
    text: "<p>Each Thursday Dementia MDT Meeting</p>",
  }
]

export { schema, meetings };